import { connect } from 'react-redux';
import TeacherRegisterStep from '../../components/TeacherRegister/TeacherRegisterStep';
import { getCurrentStep } from '../../reducers/register';

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
});

export default connect(mapStateToProps)(TeacherRegisterStep);
